// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3znFJ","title":"Images45_title__14PAp","images":"Images45_images__1j5Yf"};